































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import normalizeWheel from 'normalize-wheel';
import avatar from 'assets/homepage/avatar.png';
import CustomizedSelect from '@/CustomizedSelect';

@Component({
  components: { CustomizedSelect },
})
export default class NavBar extends Vue {
    hide = false;

    popoverShow = false;

    wholews = '0';

    keyword = '';

    searchType = 'serviceOrg';

    customizedName = '全国';

    searchTypeList = [
      { label: '服务机构', value: 'serviceOrg' },
      { label: '服务产品', value: 'serviceProduct' },
      { label: '服务需求', value: 'serviceRequire' },
      { label: '专业知识', value: 'knowledge' },
    ];

    changeName(name: string) {
      this.customizedName = name;
      this.$emit('change-customized');
    }

    changeFixed(e: Event) {
      const { spinY } = normalizeWheel(e);
      this.hide = spinY > 0 && window.pageYOffset !== 0;
    }

    toBasic() {
      this.$router.push({ name: 'basicInfo' });
    }

    search() {
      this.$router.push({
        name: this.searchType,
        query: {
          wholews: this.wholews,
          keyword: this.keyword,
        },
      });
    }

    mounted() {
      document.addEventListener(normalizeWheel.getEventType(), this.changeFixed);
      this.$store.dispatch('GetUserDetail');
      const customized = Vue.ls.get('customized');
      if (customized) this.customizedName = customized.name;
    }

    beforeDestroy() {
      document.removeEventListener(normalizeWheel.getEventType(), this.changeFixed);
    }

    get user() {
      return {
        ...this.$store.state.user,
        avatar: this.$store.state.user.avatar || avatar,
      };
    }

    confirmLogout() {
      this.$confirm('是否确认退出登录', '退出登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('Logout').then(() => {
          this.$message.success('注销成功！');
          this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } }).then(() => {
            window.location.reload();
          });
        });
      });
    }

    @Watch('$route')
    onRouteChange() {
      this.hide = false;
    }
}
